import { render, staticRenderFns } from "./shandongOne.vue?vue&type=template&id=6c707f3f&scoped=true&"
import script from "./shandongOne.vue?vue&type=script&lang=js&"
export * from "./shandongOne.vue?vue&type=script&lang=js&"
import style0 from "./shandongOne.vue?vue&type=style&index=0&id=6c707f3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c707f3f",
  null
  
)

export default component.exports